import * as React from "react";

import "./StatusIndicator.scss"

const statusStyles = {
    success: { color: 'green' },
    error: { color: 'red' },
    warning: { color: 'orange' },
};

export const StatusIndicator = ({ status, message , show_indicator = true }) => {

    return (
        <div className="status-indicator">
            { show_indicator && (
                <>
                    <span className={`status-indicator__dot ${status}`}></span>
                    <span className={`status-indicator__ping ${status}`}></span>
                </>
            )}
            <span>{message}</span>
        </div>
    );
};

export default StatusIndicator;
